// @flow
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Breadcrumb from 'components/fragments/Breadcrumb';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import SideBillboardCard from 'components/billboard/SideBillboardCard';
import Sidebar from 'components/sidebar/Sidebar';
import BackgroundImage from 'components/fragments/BackgroundImage';

import type { Status } from 'types/Status';
import type { BlocContent } from 'types/NewsletterBloc';
import type { CategoryArticleType, ArticleType } from 'types/Article';

export type StateProps = {
  categoriesArticle: CategoryArticleType[],
};

type Props = {
  title: string,
  featured_media: {
    src: string,
    legend: string,
  },
  excerpt: string,
  meta_description: string,
  status: Status,
  description: BlocContent[],
  sidebar: BlocContent[],
  match: {
    params: {
      slug: string,
    }
  },
  label: {
    id: number,
    name: string,
    slug: string
  },
  pageSlug: string,
} & StateProps;

type State = {
  partnersNews: ArticleType[],
};

class PagePartners extends Component<Props, State> {
  state = {
    partnersNews : [],
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    const { categoriesArticle, label } = props;
    const { partnersNews } = state;
    if (label && label.id && categoriesArticle.length && !partnersNews.length) {
      const partnersNews = categoriesArticle.reduce((acc, { id, items }) => {
        if (parseInt(id, 10) === parseInt(label.id, 10)) {
          const firstThreeNews = items.slice(0, 3);
          acc.push(...firstThreeNews);
        };

        return acc;
      }, []);
      return { partnersNews };
    }
    return null;
  }

  renderBlocContent = () => {
    const { description } = this.props;
    return description.map<any>((blocProps, index) => {
      return (
        <ContentBloc key={index} {...blocProps} />
      );
    });
  }

  renderPartnerNews = (): React$Element<'div'>[] | null => {
    const { partnersNews } = this.state;
    
    if (partnersNews.length) {
      return partnersNews.map((news: ArticleType): React$Element<'div'> => (
        <div key={`actu-partenaire-${news.slug}`} className="col col-md-6 col-lg-4">
          <SideBillboardCard content={news} />
        </div>
      ));
    }
    return null;
  }

  render() {
    const { renderPartnerNews, renderBlocContent } = this;
    const {
      featured_media,
      title,
      excerpt,
      sidebar,
    } = this.props;

    const { partnersNews } = this.state;

    let bannerClass = "banner";

    return (
      <>
        <section className={bannerClass}>
          <BackgroundImage
            className="banner__thumbnail img-blue-dark"
            illustration={featured_media.src}
            baliseImg={false}
          />
          <div className="container">
            <Breadcrumb elements={[{ name: 'accueil', to: '/' }, title]} isDark />
            <h1 className="ft-h2">{title}</h1>
            {excerpt &&
            <p className="banner__desc">
              {excerpt}
            </p>}
          </div>
        </section>
        <div className="container">
          <div className="row">
            <div className="col col-md-8 col-lg-9 bg-overflow">
              <div className="col col-lg-8on9">
                <div className="page mt-2 mt-md-0">
                  {(partnersNews.length > 0) && (
                    <div className="page__article">
                      <h2 className="ft-h3 mb-4 mt-md-0 is-inline">Actualités des partenaires</h2>
                      <Link
                        to='/actualites'
                        className="link-chevron link-chevron--right">
                          <span>Voir toutes les actualités</span>
                          <i className="icon icon-chevron-right" />
                      </Link>
                      <div className="row mb-7">
                        {renderPartnerNews()}
                      </div>
                    </div>
                  )}
                {renderBlocContent()}
                </div>
              </div>
            </div>
            <Sidebar sidebarContent={sidebar} />
          </div>
        </div>
      </>
    );
  }
}

export default PagePartners;
